import { CollectionManagement } from './collectionManagement.model';

export class PortfolioManagement {
  fkIdPortfolioState: number
  portfolioStateName: string
  idPortfolio: string
  idPolicy: number
  totalValue: number
  idBranch: string
  branchName: string
  idOffice: number
  officeName: string
  portfolioBalance: number
  fkIdAnnexed: number
  letterNumber: number//numero de la carta
  letterDate: string
  lastMailingNumber: string
  idAgent: number
  agentName: string;
  blockManagement: boolean = false
  portfolioAge: number
  managementList: CollectionManagement[]
}
